/* bb-inline-banners.js — Bara Bros Inline Collection Banners v1 */
(function () {
  'use strict';

  var cfg = window.BBInlineBanners;
  if (!cfg || !cfg.enabled) return;

  /* ── Slideshow ───────────────────────────────────────────────── */
  function initSlideshow(card) {
    var wrap   = card.querySelector('.bb-ib__slides');
    if (!wrap) return;
    var slides = Array.from(wrap.querySelectorAll('.bb-ib__slide'));
    if (slides.length < 2) return;
    var dots   = Array.from(card.querySelectorAll('.bb-ib__dot'));
    var speed  = parseInt(card.dataset.bbIbSpeed || '4000', 10);
    var idx    = 0;
    var timer  = null;

    function activate(n) {
      slides[idx].classList.remove('bb-ib__slide--active');
      if (dots[idx]) dots[idx].classList.remove('bb-ib__dot--active');
      idx = ((n % slides.length) + slides.length) % slides.length;
      slides[idx].classList.add('bb-ib__slide--active');
      if (dots[idx]) dots[idx].classList.add('bb-ib__dot--active');
    }
    function start() { timer = setInterval(function () { activate(idx + 1); }, speed); }
    function stop()  { clearInterval(timer); timer = null; }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stop(); activate(i); start(); });
    });
    card.addEventListener('mouseenter', stop);
    card.addEventListener('mouseleave', function () { if (!timer) start(); });

    /* Touch swipe */
    var tx = 0;
    card.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    card.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) { stop(); activate(dx < 0 ? idx + 1 : idx - 1); start(); }
    }, { passive: true });

    activate(0);
    start();
  }

  /* ── Countdown ───────────────────────────────────────────────── */
  function initCountdown(card) {
    var el = card.querySelector('[data-bb-ib-end]');
    if (!el) return;
    var end = new Date(el.dataset.bbIbEnd);
    if (isNaN(end.getTime())) return;
    var dEl = el.querySelector('[data-cd-d]');
    var hEl = el.querySelector('[data-cd-h]');
    var mEl = el.querySelector('[data-cd-m]');
    var sEl = el.querySelector('[data-cd-s]');
    var t;

    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { clearInterval(t); el.style.display = 'none'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    t = setInterval(tick, 1000);
    tick();
  }

  /* ── CTA click glow ──────────────────────────────────────────── */
  function initCtaGlow(card) {
    card.querySelectorAll('.bb-ib__cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.add('bb-ib--clicked');
        setTimeout(function () { btn.classList.remove('bb-ib--clicked'); }, 650);
      });
    });
  }

  /* ── Whole-banner click link ─────────────────────────────────── */
  function initLink(card) {
    var href   = card.dataset.bbIbLink;
    var target = card.dataset.bbIbTarget || '_self';
    if (!href) return;
    card.addEventListener('click', function (e) {
      if (e.target.closest('a,button')) return;
      if (target === '_blank') {
        window.open(href, '_blank', 'noopener');
      } else {
        window.location.href = href;
      }
    });
  }

  /* ── Init one banner card ────────────────────────────────────── */
  function initCard(card) {
    if (card.dataset.bbIbReady) return;
    card.dataset.bbIbReady = '1';
    initSlideshow(card);
    initCountdown(card);
    initCtaGlow(card);
    initLink(card);
  }

  /* ── Inject banners on infinite-scroll pages ─────────────────── */
  function injectOnScroll() {
    var grid = document.getElementById('product-grid');
    if (!grid || !cfg.banners) return;

    /* Count only real product items (not our banner wrappers) */
    var items = Array.from(
      grid.querySelectorAll('.product-grid__item:not(.bb-ib-wrap)')
    );

    cfg.banners.forEach(function (b) {
      if (!b.enabled || !b.html) return;
      var pos = b.insert_after; /* 1-based */
      if (items.length < pos) return;

      var target = items[pos - 1]; /* the product after which we inject */

      /* Skip if already injected */
      var sib = target.nextElementSibling;
      if (sib && sib.classList.contains('bb-ib-wrap') && sib.dataset.bbIbNum === String(b.num)) return;

      target.insertAdjacentHTML('afterend', b.html);
      var injected = target.nextElementSibling;
      if (injected) {
        var card = injected.querySelector('.bb-ib');
        if (card) initCard(card);
      }
    });
  }

  /* ── Boot ────────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('.bb-ib').forEach(function (card) {
      initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Hook into infinite scroll */
  document.addEventListener('productsLoaded', injectOnScroll);

})();
